/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/login',
    view: 'User/Login',
    meta: {}
  },
  {
    path: '/home',
    view: 'Home',
    meta: { credentials: [] }
  },
  {
    name: 'temps-home',
    path: '/temps',
    view: 'Temps/Home',
    meta: { credentials: ['ROLE_TEMPS_SHOW'] },
    children: [
      {
        name: 'temps-saisie',
        path: 'saisie',
        view: 'Temps/Saisie',
        meta: { credentials: ['ROLE_TEMPS_SAISIE_EDIT'] },
        children: []
      },
      {
        name: 'temps-synthese',
        path: 'synthese',
        view: 'Temps/Synthese',
        meta: { credentials: ['ROLE_TEMPS_SYNTHESE_SHOW'] },
        children: []
      }
    ]
  },
  {
    name: 'config-home',
    path: '/config',
    view: 'Config/Home',
    meta: { credentials: ['ROLE_CONFIG_SHOW'] },
    children: [
      {
        name: 'config-client-list',
        path: 'clients',
        view: 'Config/Clients/List',
        meta: { credentials: ['ROLE_CONFIG_CLIENT_SHOW'] },
        children: [

        ]
      },
      {
        name: 'config-tarif-horaire-list',
        path: 'tarif-horaire',
        view: 'Config/TarifHoraire/List',
        meta: { credentials: ['ROLE_CONFIG_TARIF_HORAIRE_SHOW'] },
        children: [

        ]
      }
    ]
  }
]
